export type ViaCepAddress = {
  cep: string;
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
};

export function onlyDigitsCep(value: string): string {
  return String(value || '').replace(/\D/g, '').slice(0, 8);
}

export function formatCepInput(value: string): string {
  const digits = onlyDigitsCep(value);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

/** Consulta ViaCEP. Retorna null se CEP inválido ou não encontrado. */
export async function lookupViaCep(cep: string): Promise<ViaCepAddress | null> {
  const digits = onlyDigitsCep(cep);
  if (digits.length !== 8) return null;
  try {
    const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    if (!response.ok) return null;
    const data = await response.json();
    if (!data || data.erro) return null;
    return {
      cep: digits,
      logradouro: String(data.logradouro || ''),
      bairro: String(data.bairro || ''),
      localidade: String(data.localidade || ''),
      uf: String(data.uf || '').toUpperCase().slice(0, 2),
      ibge: String(data.ibge || '').replace(/\D/g, '').slice(0, 7),
    };
  } catch {
    return null;
  }
}
